import arrowImg from "../../assets/icons/Right_Arrow.svg";
import InsightsStrip from "../../components/insightsstrip/InsightsStrip";

const CaseStudies = () => {
  const insightsData = [
    {
      title: "Driving Revenue Through Intelligent Fleet Automation",
      subtitle:
        "Automating Driver Rostering and Compliance for a Leading Singapore Ride-Hailing Operator",
      link: "/case-studies/intelligent-fleet-automation-revenue-growth",
    },
    {
      title:
        "Ensuring Stability in Agritech SaaS: Leadership Transition Without Disruption",
      subtitle:
        "Stabilized a rapidly growing Agritech SaaS platform during a critical leadership transition, ensuring zero",
      link: "/case-studies/agritech-saas-leadership-transition-stability",
    },
    // {
    //   title: "Success Stories",
    //   subtitle:
    //     "Discover how leading organizations turn complexity into measurable outcomes",
    //   link: "/success-stories",
    // },
  ];

  return <InsightsStrip items={insightsData} arrowImage={arrowImg} />;
};

export default CaseStudies;
